/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';
import { type OperationRequestBodyContent } from 'openapi-typescript-helpers';
import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type PutAnnotationPathParams = NonNullable<operations['putAnnotation']['parameters']['path']>;

export type PutAnnotationRequestBody = OperationRequestBodyContent<operations['putAnnotation']>;

export interface Input extends PutAnnotationPathParams {
  apiVersion?: string;
  body: PutAnnotationRequestBody;
}

export async function putAnnotation(
  { apiVersion, body, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().PUT('/internal/projects/{projKey}/environments/{envKey}/annotations/{traceId}/spans/{spanId}', {
    params: { path },
    body,
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
